import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["root"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import 'intersection-observer';
import * as React from 'react';
import useLayoutEffect from '@react-hook/passive-layout-effect';
function useIntersectionObserver(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$root = options.root,
    root = _options$root === void 0 ? null : _options$root,
    _options$pollInterval = options.pollInterval,
    pollInterval = _options$pollInterval === void 0 ? null : _options$pollInterval,
    _options$useMutationO = options.useMutationObserver,
    useMutationObserver = _options$useMutationO === void 0 ? false : _options$useMutationO,
    _options$rootMargin = options.rootMargin,
    rootMargin = _options$rootMargin === void 0 ? '0px 0px 0px 0px' : _options$rootMargin,
    _options$threshold = options.threshold,
    threshold = _options$threshold === void 0 ? 0 : _options$threshold,
    _options$initialIsInt = options.initialIsIntersecting,
    initialIsIntersecting = _options$initialIsInt === void 0 ? false : _options$initialIsInt;
  var _React$useState = React.useState(function () {
      return {
        boundingClientRect: null,
        intersectionRatio: 0,
        intersectionRect: null,
        isIntersecting: initialIsIntersecting,
        rootBounds: null,
        target: null,
        time: 0
      };
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    entry = _React$useState2[0],
    setEntry = _React$useState2[1];
  var _React$useState3 = React.useState(function () {
      return getIntersectionObserver({
        root: root,
        pollInterval: pollInterval,
        useMutationObserver: useMutationObserver,
        rootMargin: rootMargin,
        threshold: threshold
      });
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    observer = _React$useState4[0],
    setObserver = _React$useState4[1];
  React.useEffect(function () {
    var observer = getIntersectionObserver({
      root: root,
      pollInterval: pollInterval,
      useMutationObserver: useMutationObserver,
      rootMargin: rootMargin,
      threshold: threshold
    });
    setObserver(observer); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [root, rootMargin, pollInterval, useMutationObserver, JSON.stringify(threshold)]);
  useLayoutEffect(function () {
    var targetEl = target && 'current' in target ? target.current : target;
    if (!observer || !targetEl) return;
    var didUnsubscribe = false;
    observer.observer.observe(targetEl);
    var callback = function callback(entries) {
      if (didUnsubscribe) return;
      for (var i = 0; i < entries.length; i++) {
        var _entry = entries[i];
        if (_entry.target === targetEl) {
          setEntry(_entry);
        }
      }
    };
    observer.subscribe(callback);
    return function () {
      didUnsubscribe = true;
      observer.observer.unobserve(targetEl);
      observer.unsubscribe(callback);
    };
  }, [target, observer]);
  return entry;
}
function createIntersectionObserver(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? null : _ref$root,
    _ref$pollInterval = _ref.pollInterval,
    pollInterval = _ref$pollInterval === void 0 ? null : _ref$pollInterval,
    _ref$useMutationObser = _ref.useMutationObserver,
    useMutationObserver = _ref$useMutationObser === void 0 ? false : _ref$useMutationObser,
    _ref$rootMargin = _ref.rootMargin,
    rootMargin = _ref$rootMargin === void 0 ? '0px 0px 0px 0px' : _ref$rootMargin,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0 : _ref$threshold;
  var callbacks = new Set();
  if (typeof IntersectionObserver === 'undefined') return null;
  var observer = new IntersectionObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(callbacks),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var callback = _step.value;
        callback(entries, observer);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  }); // @ts-ignore

  observer.POLL_INTERVAL = pollInterval; // @ts-ignore

  observer.USE_MUTATION_OBSERVER = useMutationObserver;
  return {
    observer: observer,
    getListeners: function getListeners() {
      return callbacks;
    },
    subscribe: function subscribe(callback) {
      return callbacks.add(callback);
    },
    unsubscribe: function unsubscribe(callback) {
      return callbacks.delete(callback);
    }
  };
}
var _intersectionObserver = /*#__PURE__*/new Map();
function getIntersectionObserver(options) {
  var root = options.root,
    keys = _objectWithoutProperties(options, _excluded);
  var key = JSON.stringify(keys);
  var base = _intersectionObserver.get(root);
  if (!base) {
    base = {};
    _intersectionObserver.set(root, base);
  }
  return !base[key] ? base[key] = createIntersectionObserver(options) : base[key];
}
export default useIntersectionObserver;